import { IAnalyticsEvents, IAnalyticsEventHandler } from '../../types';

export const eventRegistry: IAnalyticsEvents = {};

export function registerAnalyticsEventHandler(
  eventName: string,
  handler: IAnalyticsEventHandler,
) {
  eventRegistry[eventName] = handler;
}
